var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('colors'),_c('basic-elements'),_c('inputs'),_c('custom-controls'),_c('navigation'),_c('javascript-components'),_c('icons'),_c('examples'),_c('download-section'),_c('carousel')],1)}
var staticRenderFns = []

export { render, staticRenderFns }